import type { JSX } from 'solid-js';

import { getSportTypeById } from '~/utils';
import { SportIdMap } from '~/constants';

interface Props extends JSX.SvgSVGAttributes<SVGSVGElement> {
  type?: 'default' | 'solid';
  sportId?: string;
}

/**
 * 统一移除下划线连接，并处理成小写命名
 * @param input
 * @returns
 */
const toCamelCase = (input: string): string => {
  return input.split('_').join('').toLowerCase();
};

export const SportIcon = (props: Props) => {
  const [split, rest] = splitProps(props, ['sportId', 'type']);

  const suffix = createMemo(() => {
    switch (split.type) {
      case 'solid':
        return 'colorful';
      default:
        return 'default';
    }
  });

  const sportName = toCamelCase(getSportTypeById(split.sportId || SportIdMap.SOCCER)!);
  return (
    <svg {...rest} viewBox="0 0 32 32" fill="currentColor">
      <use href={`/bz/sports-sprite.svg#${sportName}-${suffix()}`} />
    </svg>
  );
};
